// The opposite side of an MB housing, handed from Save & Submit to the relaunch that configures
// it. "Configure the opposite side" stores the server's mirror here and reloads the tab; the
// reload opens the same New Config (same URL, same NetSuite opener), and PredictLaunch applies
// this instead of asking for a launch prediction. sessionStorage: this tab only, and it survives
// the reload. Every access is guarded -- storage can be blocked, and then the reload simply
// launches as usual (where the launch's own MB mirror usually finds the same housing anyway).

import type { PredictionResponse } from "./predictionClient";

const KEY = "cpq2.pendingMirror";
const MAX_AGE_MS = 10 * 60 * 1000;

type Pending = { product: string; customerId: string | null; at: number; response: PredictionResponse };

export function stashOppositeSide(product: string, customerId: string | null, response: PredictionResponse): boolean {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ product, customerId, at: Date.now(), response } satisfies Pending));
    return true;
  } catch {
    return false;
  }
}

function read(): Pending | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    const p = raw ? (JSON.parse(raw) as Pending) : null;
    return p && p.response && Date.now() - p.at < MAX_AGE_MS ? p : null;
  } catch {
    return null;
  }
}

/** The configurator the pending opposite side belongs to, so the relaunch skips the picker. */
export function pendingOppositeProduct(): string | null {
  return read()?.product ?? null;
}

/** The pending opposite side for this launch, removed as it is taken. */
export function takeOppositeSide(product: string, customerId: string | null): PredictionResponse | null {
  const p = read();
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* nothing to clear */
  }
  return p && p.product === product && (p.customerId ?? null) === (customerId ?? null) ? p.response : null;
}
